// src/pages/LandingPage.jsx

import {
  HomeHero,
  NewHereBand,
  RecentlyViewedSection,
  BestSellersSection,
} from "components";

/**
 * The reference HOME, and nothing else (on request; the app-only sections that
 * used to follow were removed in the same pass):
 *
 * 1. `HomeHero` — the brand hero + the reference's promo banner slides.
 * 2. `RecentlyViewedSection` — the "Order again"-styled recents rail (hides
 *    itself without history).
 * 3. `BestSellersSection` — the "Popular right now" rail, so a first-time
 *    visitor still gets a full product slot. Independent sections on request —
 *    the PDP mounts the recents rail alone.
 * 4. `NewHereBand` — the signed-out "New to Dens 'N Dente?" band (gates itself).
 *
 * The retired sections (`Catalogues`, `ShopByBrand`, `GlovesHighlight`, `FAQs`,
 * `MailingList`, and earlier `HeroCarousel` / `MainSection` / `CategoryTiles`)
 * still exist as components — the dead list in
 * `dnd-frontend-ui/references/deprecated.md` tracks them. (`BestSellersSection`
 * was on that list; the name was revived for the DS rail.)
 */
const LandingPage = () => {
  return (
    <div className="min-h-screen font-sans">
      <HomeHero />
      <RecentlyViewedSection />
      <BestSellersSection />
      <NewHereBand />
    </div>
  );
};

export default LandingPage;
